import i18n from '../i18n/config';

export const withTranslation = (key: string, value: string): string => i18n.t(`${key}:${value}`);
